import { Component, Input, OnInit } from '@angular/core';
import { AuthService } from '@/shared/services';
import { ToolTab } from '@/core/interfaces';

type Tool = 'financial aid';

@Component({
  selector: 'financial-aid-main-content',
  templateUrl: './financial-aid-main-content.component.html',
  styleUrls: ['./financial-aid-main-content.component.css'],
  standalone: false,
})
export class FinancialAidMainContentComponent implements OnInit {
  @Input({ required: true }) tool!: Tool;

  public toolTabButtons!: ToolTab[];
  constructor(public authService: AuthService) {}

  ngOnInit(): void {
    this.toolTabButtons = [
      {
        text: 'Financial Aid Tool',
        link: '/financial-aid-tools/financial-aid',
        shouldShow: this.authService.hasPermission(
          'financial-aid-tools/financial-aid',
        ),
        isActive: this.tool === 'financial aid',
      },
    ];
  }
}
